<template>
  <div>
    <div
      v-if="orderNumber"
    >
      Оплата заказа <span class="link link_color_blue load-order-info" @click="showOrderPopup">№{{ orderNumber }}</span>
    </div>
    <div
      v-else-if="!orderNumber && receipt"
    >
      Оплата заказа №{{ receipt }}
    </div>

    {{ description }}
  </div>
</template>

<script>
export default {
  name: "history-description",

  props: {
    orderNumber: {
      type: String,
      default: '',
    },
    receipt: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
  methods: {
    showOrderPopup() {
      this.$f.showOldOrderPopup(this.orderNumber);
    }
  }
}
</script>

<style lang="scss">
  .load-order-info {
    cursor: pointer;
    text-decoration: underline;
  }
</style>